// src/pages/Dashboard/components/CasePanel/JurisprudenceSection/JurisprudenceTableRow.js

import React from 'react';

/**
 * Linha individual da tabela de jurisprudências
 * @param {object} jurisprudencia - Objeto da jurisprudência
 * @param {function} onClick - Callback ao clicar na linha
 * @param {function} onRemove - Callback para remover
 */
const JurisprudenceTableRow = ({ jurisprudencia, onClick, onRemove }) => {
  const handleRemove = (e) => {
    e.stopPropagation();
    onRemove(jurisprudencia.id);
  };

  return (
    <div 
      className="table-row-dashboard"
      onClick={(e) => onClick(jurisprudencia, e)}
      title="Clique para ver detalhes"
    >
      <div className="col-tribunal-dashboard">
        <span className={`tribunal-badge ${jurisprudencia.tribunal_origem?.toLowerCase()}`}>
          {jurisprudencia.tribunal_origem || 'N/A'}
        </span>
      </div>
      <div className="col-data-dashboard">
        {jurisprudencia.data_acordao ? 
          new Date(jurisprudencia.data_acordao).toLocaleDateString('pt-PT') : 
          'N/A'
        }
      </div>
      <div className="col-processo-dashboard">
        {jurisprudencia.meio_processual || 'N/A'}
      </div>
      <div className="col-acoes-dashboard">
        <button 
          className="btn-remover"
          onClick={handleRemove}
          title="Remover associação"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default JurisprudenceTableRow;